<template lang="html">
<header class="sl-header">
  <slider-mini :showMiniMenu.sync="showMiniMenu" v-show="showMiniMenu"></slider-mini>
  <div v-if="showMiniMenu" class="sl-mini-sidebar-mask" @click="showMiniMenu = false"></div>
  <div class="sl-menu-icon" @click="showMiniMenu = true;$ga.event('Button', 'showMiniMenu', 'Navigator')"> </div>
  <div class="sl-header-logo">
    <img :src="`/static/${$store.state.theme.name}/logo_login.png`" />
  </div>
  <div class="sl-path-title"> {{ $store.state.nav.navtitle }} </div>
  <el-popover popper-class="sl-el-pop" ref="setting" v-model="settingPopoverVisible" placement="bottom" width="140" trigger="click">
    <div v-for="it in $store.state.user.setting.children" class="sl-setting-item" :class="{
      'sl-setting-item-active': $route.path === it.url}">
      <router-link tag="div" :to="{path: `${it.url}`}" class="sl-user-li" @click.native="settingPopoverVisible = false">
        <i class="sl-icon-spot" :class="{'sl-icon-spot-cell': $store.state.userAgent.isPhone }"></i>
        <span>{{it.name}}</span>
      </router-link>
    </div>
  </el-popover>
  <el-popover popper-class="sl-el-pop" ref="user" placement="bottom" width="140" trigger="click">
    <div class="sl-setting-item">
      <div class="sl-user-li" @click="onSignOut">
        <i class="sl-icon-spot" :class="{'sl-icon-spot-cell': $store.state.userAgent.isPhone }"></i>
        <span>{{$t('Navigator.signOut')}}</span>
      </div>
    </div>
  </el-popover>
  <div class="sl-right-icons">
    <ul>
      <li v-if="$store.state.theme.companyInfo.international" class="language" @click="dialogVisible = true;$ga.event('Button', 'Show Change Language Icon', 'Navigator')"></li>
      <router-link :class="{'sl-setting-active': $route.path === '/settings/qrcode'}" class="qrcode" :to="{ path: '/settings/qrcode'}" tag="li"></router-link>
      <li :class="{'sl-setting-active': settingActive}" class="setting" v-popover:setting></li>
      <li class="user" v-popover:user></li>
    </ul>
  </div>
  <div class="sl-mask" v-show="dialogVisible">
    <div class="sl-lang" v-show="!changeLoading">
      <i @click="dialogVisible = false">X</i>
      <p class="sl-item" @click="onChange('en')" :class="{'sl-lang-active': $store.state.user.userinfo.lang === 'en'}" type="text" :plain="true">English</p>
      <p class="sl-item" @click="onChange('th')" :class="{'sl-lang-active': $store.state.user.userinfo.lang === 'th'}" type="text" :plain="true">ภาษาไทย</p>
    </div>

    <div class="sl-lang" v-show="changeLoading">
      <p>{{$t('Navigator.changeLang')}}</p>
    </div>
  </div>
</header>
</template>
<script>
import api from './api'
import * as types from './store/types'
import SliderMini from './Slider-mini'
import _ from 'lodash'
import './assets/styles/navibar.css'
export default {
  name: 'NaviBar',
  components: {
    SliderMini
  },
  data() {
    return {
      showMiniMenu: false,
      dialogVisible: false,
      changeLoading: false,
      settingPopoverVisible: false
    }
  },
  computed: {
    settingActive() {
      const index = _.findIndex(this.$store.state.user.setting.children, {
        'url': this.$route.path
      })
      return index !== -1 ? true : !true
    }
  },
  methods: {
    onChange(val) {
      this.$ga.event('Button', 'Change Language:' + val, 'Navigator')
      const vm = this
      this.changeLoading = true
      api.changeLanguage({
        lang: val
      }).then(res => {
        if (res.data.code === 200 && res.data.data.lang) {
          vm.$i18n.locale = val
          vm.$store.commit(types.CHANGELANG, res.data.data.lang)
          api.getMenu().then(res => {
            if (res.data.code === 200) {
              vm.$store.commit(types.SLIDER, res.data.data)
              location.reload()
            }
          })
        } else {
          alert(this.$t('Notify.errorMsg'))
        }
      })
    },
    onSignOut() {
      this.$ga.event('Button', 'Sign out', 'Navigator')
      const message = {
        info: this.$t('Navigator.signOutTips'),
        tip: this.$t('Navigator.tip'),
        confirm: this.$t('Navigator.confirm'),
        cancel: this.$t('Navigator.cancel')
      }
      this.$confirm(message.info, message.tip, {
        confirmButtonText: message.confirm,
        cancelButtonText: message.cancel,
        type: 'warning'
      }).then(() => {
        api.Logout(this.$store.state.user.userinfo.id).then(res => {
          if (res.data.code === 200) {
            this.$store.commit(types.SIGNOUT)
            this.$router.push({
              path: '/login'
            })
          }
        })
      }).catch(() => {
        console.log('推出失败，请稍后再试！')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// NaviBar.vue?36e86476